import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dropdown"]

  connect() {
    // Add a small delay to handle rapid mouse movements
    this.hideTimeout = null
    this.isOpen = false

    // Detect if we're on mobile
    this.isMobile = window.innerWidth < 768 // 768px is typical md breakpoint

    // Add resize listener to update mobile detection
    this.resizeListener = this.updateMobileStatus.bind(this)
    window.addEventListener('resize', this.resizeListener)
  }

  disconnect() {
    // Clean up event listener
    window.removeEventListener('resize', this.resizeListener)
  }

  updateMobileStatus() {
    this.isMobile = window.innerWidth < 768
  }

  toggle(event) {
    event.preventDefault()

    if (this.isOpen) {
      this.hideDropdownNow()
    } else {
      this.showDropdownNow()
    }
  }

  showDropdown() {
    // Only use hover behavior on desktop
    if (!this.isMobile) {
      // Clear any pending hide timeout
      if (this.hideTimeout) {
        clearTimeout(this.hideTimeout)
        this.hideTimeout = null
      }

      this.showDropdownNow()
    }
  }

  showDropdownNow() {
    // Show the dropdown
    this.dropdownTarget.classList.remove("hidden")
    this.dropdownTarget.classList.add("block")
    this.isOpen = true
  }

  hideDropdown() {
    // Only use hover behavior on desktop
    if (!this.isMobile) {
      // Set a timeout to hide the dropdown to give user time to move to the dropdown
      this.hideTimeout = setTimeout(() => {
        this.hideDropdownNow()
      }, 150) // 150ms delay gives time for mouse to move to dropdown
    }
  }

  hideDropdownNow() {
    this.dropdownTarget.classList.remove("block")
    this.dropdownTarget.classList.add("hidden")
    this.isOpen = false
  }

  // This prevents the dropdown from hiding when mouse is over the dropdown
  keepOpen() {
    if (!this.isMobile && this.hideTimeout) {
      clearTimeout(this.hideTimeout)
      this.hideTimeout = null
    }
  }

  // This starts the hide process when mouse leaves the dropdown
  startHide() {
    if (!this.isMobile) {
      this.hideDropdown()
    }
  }
}
